import { Injectable } from '@angular/core';
import { TrxService } from '~services/trx/trx.service';
import { createFeatureFlagClient, FeatureFlagUser, FeatureFlagClient } from '@zip/feature-flag-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  featureFlagClient: FeatureFlagClient;

  constructor(private trxService: TrxService) {}

  async init(user: FeatureFlagUser) {
    this.featureFlagClient = createFeatureFlagClient(this.trxService.analytics, {
      deploymentKey: environment.zipFeatureFlag.deploymentKey,
      environment: environment.zipFeatureFlag.env,
    });

    await this.featureFlagClient.start(user);
  }

  isFeatureEnabled(key: string) {
    const featureFlag = this.featureFlagClient.getFeatureFlag(key);

    return !!featureFlag;
  }
}
